import { lazy } from "react";

export { COMPENSATORY_TIME_OFF_REQUESTS_PATH } from "./path";
export const CompensatoryTimeOffRequestsPage = lazy(() => import("./page"));
